import React, { useState } from 'react';
import Modal from 'react-modal';
import ImageUploader from 'react-image-upload';
import 'react-image-upload/dist/index.css';
import CustomCheckbox from 'react-custom-checkbox';
import './CreatePostModal.css';
import { useUser } from '../loggedUserContext/LoggedUserContext';
import TagSelect from '../tagSelect/TagSelect'; // Import the TagSelect component
import { FaCheckSquare, FaSquare } from 'react-icons/fa';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    maxHeight: '80%',
    overflow: 'auto',
  },
};

Modal.setAppElement('#root');

const CreatePostModal = ({ isOpen, onRequestClose }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [photos, setPhotos] = useState([]);
  const [photoInputs, setPhotoInputs] = useState([0]);
  const [selectedTags, setSelectedTags] = useState([]); // Use the selectedTags state
  const [isPublic, setIsPublic] = useState(true); // State to manage the "is public" checkbox
  const { userId } = useUser();

  console.log('User ID:', userId);

  const getImageFileObject = (imageFile, index) => {
    setPhotos((prevPhotos) => {
      const updatedPhotos = [...prevPhotos];
      updatedPhotos[index] = imageFile;
      return updatedPhotos;
    });

    setPhotoInputs((prevInputs) => [...prevInputs, photoInputs.length]);
  };

  const runAfterImageDelete = (imageFile, index) => {
    setPhotos((prevPhotos) => prevPhotos.filter((_, i) => i !== index));
    if (photoInputs.length > 1) {
      setPhotoInputs((prevInputs) => prevInputs.filter((_, i) => i !== index));
    }
  };

  const resetForm = () => {
    setTitle('');
    setContent('');
    setPhotos([]);
    setPhotoInputs([0]);
    setSelectedTags([]);
    setIsPublic(true); // Reset the "is public" state
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    photos.forEach((photo) => {
      formData.append('photos', photo.file);
    });

    fetch(`${process.env.REACT_APP_API_URL}/uploadPhotos`, {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Photos uploaded:', data);
        let photosFileNames = data.files.map(photo => photo.filename);

        fetch(`${process.env.REACT_APP_API_URL}/posts`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id_user: userId,
            titlu: title,
            text_postare: content,
            images: photosFileNames,
            tags: selectedTags.map(tag => tag.value), // Use selectedTags to get the tag values
            is_public: isPublic, // Pass the "is public" state
            timestamp: new Date(new Date().getTime() + ((new Date().getTimezoneOffset() < -60 ? 3 : 2) * 60 * 60 * 1000)).toISOString().slice(0, 19).replace('T', ' ')
          })
        })
          .then((response) => response.json())
          .then((data) => {
            console.log('New post created:', data);
          })
          .catch((error) => {
            console.error('Error creating new post:', error);
          });

      }).catch((error) => {
        console.error('Error uploading photos:', error);
      });

    resetForm();
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel="New Discussion Modal"
    >
      <div className="modal-header">
        <h5 className="modal-title">Creeaza o discutie noua</h5>
      </div>
      <div className="modal-body">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="discussionTitle">Titlu</label>
            <input
              type="text"
              className="form-control"
              id="discussionTitle"
              placeholder="Introdu titlul discutiei"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="discussionContent">Continut</label>
            <textarea
              className="form-control"
              id="discussionContent"
              rows="3"
              placeholder="Introdu textul discutiei"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              required
            ></textarea>
          </div>
          <div className="mb-3">
            <label>Incarca Imagini</label>
            <br />
            <div className="file-uploader-container">
              {photoInputs.map((input, index) => (
                <ImageUploader
                  key={input}
                  onFileAdded={(img) => getImageFileObject(img, index)}
                  onFileRemoved={(img) => runAfterImageDelete(img, index)}
                />
              ))}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="tags">Taguri</label>
            <TagSelect
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
            />
          </div>
          <div className="d-flex align-items-center mb-3 mt-3">
            <label className="me-2">Seteaza postarea pe public</label>
            <CustomCheckbox
              checked={isPublic}
              onChange={(value) => setIsPublic(value)}
              icon={
                <div
                  style={{
                    display: 'flex',
                    flex: 1,
                    backgroundColor: isPublic ? 'lightblue' : '#fff',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: isPublic ? '#fff' : 'black',
                    borderRadius: 3,
                    fontSize: 18,
                  }}
                >
                  {isPublic ? <FaCheckSquare /> : <FaSquare />}
                </div>
              }
              borderColor="lightblue"
              borderWidth={2}
              borderRadius={3}
              size={20}
            />
          </div>
          <p style={{fontSize: "12px",color: "gray"}}>
            *Postarile publice se vor putea distribui si in afara comunitatii 4construct de catre alti membrii ai acesteia
          </p>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onRequestClose}>Close</button>
            <button type="submit" className="btn btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default CreatePostModal;
